import restApi from '@/utils/rest-api'

export default {
    scanQrSpot(payload) {
        return restApi.post('qr-spot-scans', payload)
    }
}
